'use client'

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { API_Error, API_Success_Response } from "@/interfaces/api/response/api_response_types"
import { useUserStore } from "@/stores/useUserStore"
import { logout } from "../requests/user"

export const useLogout = () => {
	const logoutLocal = useUserStore((state) => state.logout)
	const queryClient = useQueryClient()

	return useMutation<API_Success_Response<undefined>, API_Error, void>({
		retry: false,
		mutationFn:  logout,
		onMutate: async () => {
      logoutLocal()
      // clear cache
      await queryClient.cancelQueries()
      queryClient.clear()
    }
	})
} 